import { RiArrowDownSLine, RiArrowUpSLine } from "@remixicon/react";
import React, {
    HTMLAttributes,
    ReactElement,
} from "react";

const ToggleIcon = React.forwardRef((
    args: HTMLAttributes<HTMLElement>,
    ref: React.ForwardedRef<HTMLElement>,
): ReactElement => (
    <span ref={ref} {...args}>
        <RiArrowDownSLine className="dropdown-toggle-icon-expand" />
        <RiArrowUpSLine className="dropdown-toggle-icon-collapse" />
    </span>
));

export default ToggleIcon;
